import { Image } from "components";
import { Dispatch, SetStateAction } from "react";
import RoofReplacementExample1 from "public/evidence-examples/roof-replacement1.png";
import RoofReplacementExample2 from "public/evidence-examples/roof-replacement2.png";
import RoofReplacementExample3 from "public/evidence-examples/roof-replacement3.png";
import RoofReplacementExample4 from "public/evidence-examples/roof-replacement4.png";
import ButtonV2 from "elements/ButtonV2";
import { PropertySurveyEvidenceModal } from "../PropertySurveyEvidenceModal";

export const EvidenceModal = (props: {
	setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
	const { setOpen } = props;

	return (
		<PropertySurveyEvidenceModal onAttemptExit={() => setOpen(false)}>
			<p>
				<b>Evidence of Roof Condition</b>
			</p>
			<div className="property-survey-evidence-modal-body-text-container">
				<p className="sm">
					<b>
						Quotes, invoices, and insurance estimates for needed roof
						replacements or repairs are one of the most effective ways to get a
						property tax reduction.
					</b>{" "}
					If your structure’s roof is in poor condition or damaged, please
					provide as much evidence and documentation of the issues as possible.
					<br />
					<br />
					Photos and written descriptions are helpful. However, the assessor’s
					office rarely grants a tax reduction without documentation showing the
					dollar value of repairs needed.
				</p>
			</div>
			<p>Example Documents & Photos</p>
			<div className="property-survey-evidence-modal-image-container-grid">
				<Image
					// openInNewTab
					placeholder="blur"
					src={RoofReplacementExample3}
					alt="Roof replacement document example image"
					quality={100}
				/>
				<Image
					// openInNewTab
					placeholder="blur"
					src={RoofReplacementExample4}
					quality={100}
					alt="Roof damange example image"
				/>
				<Image
					// openInNewTab
					placeholder="blur"
					src={RoofReplacementExample2}
					alt="Second roof damage example image"
					quality={100}
				/>
				<Image
					// openInNewTab
					placeholder="blur"
					src={RoofReplacementExample1}
					alt="Third roof damage example image"
					quality={100}
				/>
			</div>
			<ButtonV2
				size="mobile-extra-small"
				onClick={() => setOpen(false)}
				className="mx-auto">
				Back to Question
			</ButtonV2>
		</PropertySurveyEvidenceModal>
	);
};
